<template>
  <Checkbox
    :modelValue="modelValue"
    class="datatable-checkbox"
    :disabled="disabled"
    @update:modelValue="$emit('update:modelValue', $event)"
    @click="$emit('click', $event)"
  />
</template>

<script>
import Checkbox from "@/components/Checkbox.vue";

export default {
  components: {
    Checkbox
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "click"]
};
</script>

<style lang="scss">
.datatable-checkbox {
  margin-bottom: 0;
  display: block !important;
  .checkbox-container {
    width: 25px !important;
    height: 25px !important;
    font-size: 12px !important;
  }
}
</style>
